import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowRight, MapPin } from "lucide-react";
import { api } from "../lib/api";
import { SEO } from "../components/SEO";
import { FadeUp } from "../components/motion";
import { useLang } from "../i18n/LanguageContext";

// Index des pages d'atterrissage par ville (SEO local : « trophées Montréal »…)
export default function Villes() {
  const { lang, t, ts } = useLang();
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/villes").then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, []);

  return (
    <div className="pt-32 pb-28 max-w-7xl mx-auto px-6 lg:px-10" data-testid="villes-page">
      <SEO
        title={`${ts("villes.title")} | Mr Trophée`}
        description={ts("villes.intro")}
        path="/villes"
      />
      <FadeUp>
        <p className="text-gold tracking-[0.3em] uppercase text-xs mb-4 flex items-center gap-2">
          <MapPin className="w-4 h-4" /> {t("villes.kicker")}
        </p>
        <h1 className="font-serif text-4xl md:text-5xl leading-tight mb-4" data-testid="villes-title">{t("villes.title")}</h1>
        <p className="text-ivory/60 text-sm leading-relaxed max-w-2xl mb-12">{t("villes.intro")}</p>
      </FadeUp>

      {!items ? (
        <div className="flex items-center justify-center py-32"><Loader2 className="w-8 h-8 animate-spin text-gold" /></div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((v, i) => {
            const title = lang === "en" ? v.title_en : v.title_fr;
            const region = lang === "en" ? v.region_en : v.region_fr;
            const meta = lang === "en" ? v.meta_en : v.meta_fr;
            return (
              <FadeUp key={v.slug} delay={Math.min(i, 7) * 0.05}>
                <Link to={`/villes/${v.slug}`} data-testid={`ville-card-${v.slug}`}
                  className="group block bg-surface border border-ivory/10 rounded-xl p-6 hover:border-gold/50 transition-colors duration-300 h-full">
                  {v.blason ? (
                    <span className="w-11 h-11 rounded-full border-2 border-gold/50 bg-ink flex items-center justify-center overflow-hidden mb-3">
                      <img src={v.blason} alt={`Armoiries de ${v.ville}`} loading="lazy" className="w-9 h-9 object-contain" data-testid={`ville-blason-${v.slug}`} />
                    </span>
                  ) : (
                    <MapPin className="w-5 h-5 text-gold mb-3" />
                  )}
                  <h2 className="font-serif text-xl leading-snug mb-1 group-hover:text-gold transition-colors duration-300">{v.ville}</h2>
                  <p className="text-[11px] uppercase tracking-widest text-ivory/45 mb-3">{region}</p>
                  <p className="text-xs text-ivory/60 leading-relaxed line-clamp-3 mb-4">{meta}</p>
                  <span className="inline-flex items-center gap-2 text-gold text-xs uppercase tracking-widest">
                    {t("villes.view")} <ArrowRight className="w-3.5 h-3.5" />
                  </span>
                </Link>
              </FadeUp>
            );
          })}
        </div>
      )}
    </div>
  );
}
